import { HighlightStyled } from './TextHighlighter.styles';

interface TextHighlighterProps {
  text: string;
  textToHighlight: string;
}

const TextHighlighter = ({ text, textToHighlight }: TextHighlighterProps) => {
  if (!textToHighlight?.trim()) {
    return text;
  }

  // We need an escaped string so that special characters don't conflict with Regex characters.
  const safeTextToHighlight = textToHighlight.replace(
    /[.*+?^${}()|[\]\\]/g,
    '\\$&',
  );

  const textParts = text.split(new RegExp(`(${safeTextToHighlight})`, 'gi'));

  return (
    <>
      {textParts.map((textPart, index) =>
        textPart.toLocaleLowerCase() === textToHighlight.toLocaleLowerCase() ? (
          <HighlightStyled key={`${textPart}-${index}`}>
            {textPart}
          </HighlightStyled>
        ) : (
          textPart
        ),
      )}
    </>
  );
};

export default TextHighlighter;
